export const INDEX = 5; //1

export const CLIENTS = [
  {
    index: 1,
    appId: "com.diet.master",
    appName: "My App",
    identifier: "testing",
  },
  {
    index: 2,
    appId: "com.go.abieta",
    appName: "Abieta",
    identifier: "abietadm",
  }, // ios: com.goabieta // android: com.go.abieta - 25nov //14jan
  {
    index: 3,
    appId: "fit.dietmaster.thunders",
    appName: "XIV Restaurant",
    identifier: "xiv",
  }, //com.envisiondiet //ios - fit.dietmaster.thunders
  {
    index: 4,
    appId: "com.dietcircle",
    appName: "Diet Circle",
    identifier: "dietcircledm",
  }, // - 25nov
  {
    index: 5,
    appId: "fit.dietmaster.chefpaul",
    appName: "Chef Paul",
    identifier: "chefpaul",
  },
  {
    index: 6,
    appId: "fit.dietmaster.eatsmart",
    appName: "Eat Smart KW",
    identifier: "eatsmart",
  }, // - 25 nov//14jan//27th Jan
  {
    index: 7,
    appId: "fit.dietmaster.nutrilifedm",
    appName: "Nutri Life KSA",
    identifier: "nutrilifedm",
  }, // - 25nov
  {
    index: 8,
    appId: "fit.dietmaster.healthchart",
    appName: "Health Chart",
    identifier: "healthchart",
  },
  {
    index: 9,
    appId: "fit.dietmaster.eightysixhealthy",
    appName: "86 Healthy",
    identifier: "86healthy",
  },
  {
    index: 10,
    appId: "com.diet.prep",
    appName: "Prep Diet",
    identifier: "prepdiet",
  },
  {
    index: 11,
    appId: "fit.dietmaster.xdiet",
    appName: "XDiet",
    identifier: "xdiet",
  },
  {
    index: 12,
    appId: "com.swaps.diet",
    appName: "Swaps Diet",
    identifier: "swaps",
  },
  {
    index: 13,
    appId: "com.roots.diet",
    appName: "Roots Diet",
    identifier: "roots",
  }, // - 20 nov
  {
    index: 14,
    appId: "com.diet.time",
    appName: "Diet Time",
    identifier: "diet-time",
  },
  {
    index: 15,
    appId: "com.ingest.diet",
    appName: "Ingest",
    identifier: "ingest",
  },
  {
    index: 16,
    appId: "com.level.diet",
    appName: "Level Diet",
    identifier: "level-diet",
  },
  {
    index: 17,
    appId: "com.lofat.lifestyle",
    appName: "Lofat Eats",
    identifier: "lofat",
  }, //com.thelofat.ios - com.lofat.lifestyle
  {
    index: 18,
    appId: "com.ghadana.lifestyle",
    appName: "Ghadana",
    identifier: "ghadana",
  },
  {
    index: 19,
    appId: "com.abietaqtr",
    appName: "Abieta Qtr",
    identifier: "abietaqtrdm",
  },
  {
    index: 20,
    appId: "my.meals.online",
    appName: "My Meals KSA",
    identifier: "mymeals",
  },
  {
    index: 21,
    appId: "com.diet.master",
    appName: "Eataami testing",
    identifier: "staging",
  },
];

/**
xiv --
healthChart --
chefpaul --
dietcircledm --
86healthy --
eatsmart --
swaps
roots --
abietaqtrdm --
ingest --
 */
